import useSWR from 'swr'

const useTranslatedLabel = (entityType, entityId, language) => {
  const { data: translatedFields, error, isValidating } = useSWR(language !== 'en' && entityId ? `/msvc/v1/translations/${entityType}/${entityId}` : null)
  return { error, translatedFields, isValidating }
}

export default useTranslatedLabel